import api from './client.js'

export const adminAPI = {
  getSystemHealth: () => api.get('/admin/system-health'),
  listIncidents: (scope = 'open', limit = 50) =>
    api.get('/admin/incidents', { params: { scope, limit } }),
  acknowledgeIncident: (id) => api.post(`/admin/incidents/${id}/acknowledge`),
  resolveIncident:     (id) => api.post(`/admin/incidents/${id}/resolve`),

  // Aggregate data voor de admin regie-schermen.
  schermProgramma:  () => api.get('/admin/scherm/programma'),
  schermDeelnemers: () => api.get('/admin/scherm/deelnemers'),
  schermTornooien:  () => api.get('/admin/scherm/tornooien'),
  schermBar:        () => api.get('/admin/scherm/bar'),
  schermPrijzen:    () => api.get('/admin/scherm/prijzen'),
  schermBroadcasts: () => api.get('/admin/scherm/broadcasts'),
  schermContainers: () => api.get('/admin/scherm/containers'),
  schermStorage:    () => api.get('/admin/scherm/storage'),
  getRegieParticipants: () => api.get('/admin/regie/participants'),
  getFailedLoginIps: () => api.get('/admin/failed-logins/ips'),
  getFailedLoginLog: () => api.get('/admin/failed-logins/log'),
  cleanupFailedLogins: () => api.post('/admin/failed-logins/cleanup'),
  getFunnelStatus: () => api.get('/admin/funnel/status'),
  funnelOn:  () => api.post('/admin/funnel/on'),
  funnelOff: () => api.post('/admin/funnel/off'),

  getPterodactylFunnelStatus: () => api.get('/admin/funnel/pterodactyl/status'),
  pterodactylFunnelOn:  () => api.post('/admin/funnel/pterodactyl/on'),
  pterodactylFunnelOff: () => api.post('/admin/funnel/pterodactyl/off'),
  getUsers: (params) => api.get('/admin/users', { params }),
  createUser: (userData) => api.post('/admin/users', userData),
  updateUser: (userId, userData) => api.put(`/admin/users/${userId}`, userData),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  resetUserPassword: (userId, password) => api.post(`/admin/users/${userId}/reset-password`, { password }),
  resetUserStats: (userId) => api.delete(`/admin/users/${userId}/stats`),
  getSystemStats: () => api.get('/admin/stats'),
  getEnhancedStats: () => api.get('/admin/stats/enhanced'),
  resetPlayerStats: () => api.delete('/admin/stats/reset'),
  deleteAllTournaments: () => api.delete('/admin/tournaments/delete-all'),
  getActivityLog: (params) => api.get('/admin/activity-log', { params }),
  logActivity: (activityData) => api.post('/admin/activity-log', activityData),
  shutdownSystem: () => api.post('/admin/system/shutdown'),
  getHub: () => api.get('/admin/hub'),
  getSetupStatus: () => api.get('/admin/setup-status'),
  broadcastNotification: (data) => api.post('/notifications/admin/broadcast', data),
}
